export default "__VITE_ASSET__2b58fab5__"